module.exports = __webpack_public_path__ + "img/badge-top-reader.63b2154d.png";